import React from 'react';
import { Navigate } from 'react-router-dom';

interface PrivateRouteProps {
  children: React.ReactNode;
  twitterUser: any;
  requireTwitterUser?: string;
}

/**
 * Route guard that requires Twitter authentication
 * Optionally requires specific Twitter username
 */
function PrivateRoute({ children, twitterUser, requireTwitterUser }: PrivateRouteProps) {
  if (!twitterUser) {
    return <Navigate to="/" replace />;
  }

  if (requireTwitterUser && twitterUser.screen_name !== requireTwitterUser) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default PrivateRoute;
